import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (this.state.error) {
      return (
        <div className="tile p-8 text-center" data-testid="error-boundary">
          <div className="text-[10px] uppercase tracking-[0.18em] text-critical font-semibold mb-2">Module Error</div>
          <h2 className="font-display text-xl font-semibold mb-2">Something went wrong rendering this view.</h2>
          <p className="text-sm text-muted max-w-md mx-auto leading-relaxed">
            The control tower shell remains operational. You can navigate to another module from the sidebar.
          </p>
          <pre className="mt-4 text-[11px] font-mono-tabular text-muted whitespace-pre-wrap text-left bg-surface-2 p-3 rounded-sm border border-border max-w-2xl mx-auto">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button onClick={this.reset} className="mt-4 px-4 h-9 bg-primary text-primary-fg rounded-sm text-sm font-semibold hover:opacity-90">
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
